import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { Grid } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import useStyles from "./style";

export default function Close() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
        className={classes.drawer}
    >
      <Grid className={classes.box}>
        <Grid className={classes.list}>
          <NavLink to="/" className={classes.togglelinks}>
            Words Dictionary
          </NavLink>
        </Grid>
        <Grid className={classes.list}>
          <NavLink to="/translater" className={classes.togglelinks}>
            Translater
          </NavLink>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <div className={classes.drawer}>
      <React.Fragment key={"right"}>
        <Button onClick={toggleDrawer("right", true)}>
          <ArrowBackIosIcon style={{ color: "#547972" }} />
        </Button>
        <SwipeableDrawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
        >
          {list("right")}
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
}
